module.exports = __webpack_public_path__ + "images/store_case_study/kld-pic1_a29923af4b2a379ccd0a5294f0edcf09.png";